import { render } from "./SurveryPlusStructure.vue?vue&type=template&id=b6f1a280&ts=true"
import script from "./SurveryPlusStructure.vue?vue&type=script&lang=ts"
export * from "./SurveryPlusStructure.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__